import React from 'react'
import ScrollToTop from '../utils/ScrollToTop.jsx'
import ContactMailContainer from '../containers/ContactMailContainer.jsx'
import ContactInfoContainer from '../containers/ContactInfoContainer.jsx'
import GoogleMapContainer from '../containers/GoogleMapContainer.jsx'
import FooterBtnContainer from '../containers/FooterBtnContainer.jsx'
import scrollTo from '../utils/scrollTo'

const Contact = () => (
    <div>
        <ScrollToTop />
        <ContactMailContainer />
        <ContactInfoContainer />
        <GoogleMapContainer />
        <FooterBtnContainer onClick={scrollTo.bind(null, '')} />
    </div>
)


export default Contact



// WEBPACK FOOTER //
// ./src/scripts/routes/Contact.jsx